<pdf-viewer [src]="caminhoArqSel"
    [render-text]="true"
    [original-size]="false"
    style="min-width: 100%; min-height: 100%; width: 400px; height: 500px">
</pdf-viewer>